import React, { useEffect } from 'react';
import { useAdminStore } from '../store/useAdminStore';

function AdminCRM() {
  const { crmTickets: tickets, setCrmTickets: setTickets, crmFeedbacks: feedbacks, setCrmFeedbacks: setFeedbacks, crmDlq: dlqEvents, setCrmDlq: setDlqEvents } = useAdminStore();
  const { deviceId } = useAdminStore();
  
  const { crmGdprEmail: gdprEmail, setCrmGdprEmail: setGdprEmail } = useAdminStore();
  const { crmTimelineEmail: timelineEmail, setCrmTimelineEmail: setTimelineEmail } = useAdminStore();
  const { crmTimelineEvents: timelineEvents, setCrmTimelineEvents: setTimelineEvents } = useAdminStore();
  const { adminIdempotencyKey, regenerateAdminIdempotencyKey } = useAdminStore();

  const [selectedDlqEvents, setSelectedDlqEvents] = React.useState([]);

  useEffect(() => {
    fetch('/api/admin/crm/tickets', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.json())
      .then(data => setTickets(Array.isArray(data) ? data : []))
      .catch(() => {});

    fetch('/api/admin/crm/feedback', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.json())
      .then(data => setFeedbacks(Array.isArray(data) ? data : []))
      .catch(() => {});

    fetch('/api/admin/dlq', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.json())
      .then(data => setDlqEvents(Array.isArray(data) ? data : []))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReplayDLQ = async (eventId) => {
    if (!window.confirm("Re-queue this failed offline event?")) return;
    try {
      const res = await fetch('/api/admin/dlq/replay', {
        method: 'POST',
        headers: { 'Idempotency-Key': adminIdempotencyKey, 'X-Device-Id': deviceId || '', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ event_id: eventId })
      });
      regenerateAdminIdempotencyKey();
      if (res.ok) {
        setDlqEvents(dlqEvents.filter(e => e.id !== eventId));
      } else {
        alert("Replay failed");
      }
    } catch {
      alert("Network error");
    }
  };

  const handleSelectDlq = (id) => {
    setSelectedDlqEvents(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };

  const handleSelectAllDlq = () => {
    if (selectedDlqEvents.length === dlqEvents.length) {
      setSelectedDlqEvents([]);
    } else {
      setSelectedDlqEvents(dlqEvents.map(e => e.id));
    }
  };

  const handleDeleteDLQ = async (id) => {
    if (!window.confirm("Delete this DLQ entry permanently?")) return;
    try {
      const res = await fetch(`/api/admin/dlq/${id}`, {
        method: 'DELETE',
        headers: { 'Idempotency-Key': adminIdempotencyKey, 'X-Device-Id': deviceId || '', 'X-Requested-With': 'XMLHttpRequest' }
      });
      regenerateAdminIdempotencyKey();
      if (res.ok) {
        setDlqEvents(dlqEvents.filter(e => e.id !== id));
        setSelectedDlqEvents(prev => prev.filter(e => e !== id));
      } else alert("Delete failed");
    } catch { alert("Network error"); }
  };

  const handleDeleteSelectedDLQ = async () => {
    if (selectedDlqEvents.length === 0) return;
    if (!window.confirm(`Delete ${selectedDlqEvents.length} selected DLQ entries permanently?`)) return;
    try {
      const res = await fetch(`/api/admin/dlq/delete-batch`, {
        method: 'POST',
        headers: { 'Idempotency-Key': adminIdempotencyKey, 'X-Device-Id': deviceId || '', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ ids: selectedDlqEvents })
      });
      regenerateAdminIdempotencyKey();
      if (res.ok) {
        setDlqEvents(dlqEvents.filter(e => !selectedDlqEvents.includes(e.id)));
        setSelectedDlqEvents([]);
      } else alert("Delete failed");
    } catch { alert("Network error"); }
  };

  const handleDeleteAllDLQ = async () => {
    if (!window.confirm("⚠️ EXTREME DANGER ⚠️\n\nWipe ALL DLQ entries permanently?")) return;
    try {
      const res = await fetch(`/api/admin/dlq`, {
        method: 'DELETE',
        headers: { 'Idempotency-Key': adminIdempotencyKey, 'X-Device-Id': deviceId || '', 'X-Requested-With': 'XMLHttpRequest' }
      });
      regenerateAdminIdempotencyKey();
      if (res.ok) {
        setDlqEvents([]);
        setSelectedDlqEvents([]);
      } else alert("Delete failed");
    } catch { alert("Network error"); }
  };



  const handleGDPRAnonymize = async (e) => {
    e.preventDefault();
    if (!window.confirm(`⚠️ EXTREME DANGER ⚠️\n\nAre you absolutely sure you want to permanently ANONYMIZE user: ${gdprEmail}?\n\nThis cannot be undone. All PII will be destroyed.`)) return;
    
    try {
      const res = await fetch('/api/admin/crm/anonymize', {
        method: 'POST',
        headers: { 'Idempotency-Key': adminIdempotencyKey, 'X-Device-Id': deviceId || '', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ email: gdprEmail })
      });
      const data = await res.json();
      regenerateAdminIdempotencyKey();
      if (data.success) {
        alert("GDPR Right-to-be-Forgotten executed successfully. User data destroyed.");
        setGdprEmail('');
      } else {
        alert("Error: " + data.error);
      }
    } catch {
      alert("Execution failed.");
    }
  };

  const fetchTimeline = async (e) => {
    e.preventDefault();
    if (!timelineEmail) return;
    try {
      const res = await fetch(`/api/admin/crm/timeline/${encodeURIComponent(timelineEmail)}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      setTimelineEvents(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleResolveTicket = async (id) => {
    if (!window.confirm("Resolve this ticket? An email will be sent to the user.")) return;
    try {
      const res = await fetch(`/api/admin/crm/tickets/${id}/resolve`, {
        method: 'POST',
        headers: { 'Idempotency-Key': adminIdempotencyKey, 'X-Device-Id': deviceId || '', 'X-Requested-With': 'XMLHttpRequest' }
      });
      regenerateAdminIdempotencyKey();
      
      if (res.ok) {
        setTickets(tickets.filter(t => t.id !== id));
      } else {
        if (res.status === 404) {
          setTickets(tickets.filter(t => t.id !== id));
          alert("Ticket was already resolved or removed.");
        } else {
          alert("Failed to resolve ticket");
        }
      }
    } catch {
      alert("Network error");
    }
  };

  const handleAcknowledgeFeedback = async (id) => {
    if (!window.confirm("Acknowledge this feedback? An email will be sent to the user.")) return;
    try {
      const res = await fetch(`/api/admin/crm/feedback/${id}/acknowledge`, {
        method: 'POST',
        headers: { 'Idempotency-Key': adminIdempotencyKey, 'X-Device-Id': deviceId || '', 'X-Requested-With': 'XMLHttpRequest' }
      });
      regenerateAdminIdempotencyKey();
      
      if (res.ok) {
        setFeedbacks(feedbacks.filter(f => f.id !== id));
      } else {
        if (res.status === 404) {
          setFeedbacks(feedbacks.filter(f => f.id !== id));
          alert("Feedback was already acknowledged or removed.");
        } else {
          alert("Failed to acknowledge feedback");
        }
      }
    } catch {
      alert("Network error");
    }
  };

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-white tracking-tight">CRM & Compliance Hub</h1>
        <p className="text-gray-400 text-sm mt-1">Unified Ticketing, Offline Job Replay, and GDPR Actions</p>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
        
        {/* SUPPORT TICKETS */}
        <div className="bg-gray-900 border border-gray-800 rounded-xl shadow-lg p-6">
          <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
            <span>🎫</span> Unified Support Inbox
          </h2>
          <div className="overflow-y-auto max-h-96 pr-2 space-y-3">
            {tickets.length === 0 ? (
              <p className="text-gray-500 text-sm italic">No open tickets.</p>
            ) : (
              tickets.slice(0, 100).map(t => (
                <div key={t.id} className="bg-gray-950 p-4 rounded border border-gray-800 relative">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <span className="font-mono font-bold text-blue-500 text-sm block mb-1">TKT-{t.id.toString().padStart(5, '0')}</span>
                      <span className="font-bold text-gray-300 text-sm">{t.user_name || 'User'}</span>
                      <span className="text-gray-500 text-xs ml-2">({t.user_email})</span>
                    </div>
                    <span className="bg-blue-900/50 text-blue-400 text-xs px-2 py-0.5 rounded border border-blue-800/50">{t.status}</span>
                  </div>
                  <h4 className="text-white font-medium mb-1">{t.subject}</h4>
                  <p className="text-gray-400 text-sm mb-4">{t.message}</p>
                  <button 
                    onClick={() => handleResolveTicket(t.id)}
                    className="bg-green-600/20 hover:bg-green-600/40 text-green-400 text-xs px-3 py-1.5 rounded border border-green-800/50 transition-colors w-full"
                  >
                    Resolve Ticket
                  </button>
                </div>
              ))
            )}
          </div>
        </div>

        {/* FEEDBACK INBOX */}
        <div className="bg-gray-900 border border-gray-800 rounded-xl shadow-lg p-6">
          <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
            <span>💬</span> User Feedback
          </h2>
          <div className="overflow-y-auto max-h-96 pr-2 space-y-3">
            {feedbacks.length === 0 ? (
              <p className="text-gray-500 text-sm italic">No open feedback.</p>
            ) : (
              feedbacks.slice(0, 100).map(f => (
                <div key={f.id} className="bg-gray-950 p-4 rounded border border-gray-800">
                  <div className="flex justify-between items-start mb-2">
                    <span className="font-bold text-green-400 text-sm">{f.name}</span>
                    <span className="text-gray-500 text-xs">{f.email}</span>
                  </div>
                  {f.subject && <h4 className="text-white font-medium text-sm mb-1">{f.subject}</h4>}
                  <p className="text-gray-400 text-sm italic mb-4">"{f.feedback_text}"</p>
                  <button 
                    onClick={() => handleAcknowledgeFeedback(f.id)}
                    className="bg-blue-600/20 hover:bg-blue-600/40 text-blue-400 text-xs px-3 py-1.5 rounded border border-blue-800/50 transition-colors w-full"
                  >
                    Acknowledge Feedback
                  </button>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="xl:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* DEAD LETTER QUEUE (DLQ) */}
          <div className="bg-gray-900 border border-gray-800 rounded-xl shadow-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-white flex items-center gap-2">
                <span>🪦</span> Dead Letter Queue (DLQ)
              </h2>
              <div className="flex gap-2">
                <button onClick={handleDeleteSelectedDLQ} disabled={selectedDlqEvents.length === 0} className="bg-red-900/50 hover:bg-red-800 text-red-300 text-xs px-3 py-1 rounded border border-red-800 disabled:opacity-50 transition-colors">
                  Delete Selected
                </button>
                <button onClick={handleDeleteAllDLQ} disabled={dlqEvents.length === 0} className="bg-red-600 hover:bg-red-500 text-white text-xs px-3 py-1 rounded transition-colors">
                  Delete All
                </button>
              </div>
            </div>
            
            <div className="overflow-y-auto max-h-48 pr-2 space-y-2">
              {dlqEvents.length === 0 ? (
                <p className="text-gray-500 text-sm italic">DLQ is empty. No offline failures.</p>
              ) : (
                <>
                  <div className="flex items-center gap-2 mb-2 px-1">
                    <input type="checkbox" checked={selectedDlqEvents.length === dlqEvents.length && dlqEvents.length > 0} onChange={handleSelectAllDlq} />
                    <span className="text-gray-400 text-xs">Select All</span>
                  </div>
                  {dlqEvents.slice(0, 100).map(e => (
                    <div key={e.id} className="bg-gray-950 p-3 rounded border border-red-900/50 flex justify-between items-center gap-3">
                      <input type="checkbox" checked={selectedDlqEvents.includes(e.id)} onChange={() => handleSelectDlq(e.id)} className="mt-1" />
                      <div className="flex-1 min-w-0">
                        <span className="text-red-400 font-mono text-xs block mb-1">[{e.event_type}]</span>
                        <span className="text-gray-500 text-xs truncate max-w-[200px] block">{e.error_reason}</span>
                      </div>
                      <div className="flex flex-col gap-1">
                        <button onClick={() => handleReplayDLQ(e.id)} className="bg-gray-800 hover:bg-gray-700 text-white text-[10px] px-2 py-1 rounded border border-gray-600">Replay</button>
                        <button onClick={() => handleDeleteDLQ(e.id)} className="bg-red-900/30 hover:bg-red-800 text-red-400 text-[10px] px-2 py-1 rounded border border-red-900/50">Delete</button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>

          {/* GDPR ANONYMIZER */}
          <div className="bg-red-950/20 border border-red-900/50 rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-bold text-red-500 mb-2 flex items-center gap-2">
              <span>⚠️</span> GDPR Right-to-be-Forgotten
            </h2>
            <p className="text-gray-400 text-xs mb-4">Hard-redact a user's PII across the entire infrastructure using cryptographic hashing.</p>
            <form onSubmit={handleGDPRAnonymize} className="flex flex-col sm:flex-row gap-2">
              <input 
                type="email" 
                required 
                value={gdprEmail}
                onChange={(e) => setGdprEmail(e.target.value)}
                placeholder="Target User Email..." 
                aria-label="Target User Email for GDPR Deletion"
                className="flex-1 bg-gray-950 border border-red-900/50 text-white rounded p-2 outline-none focus:border-red-500"
              />
              <button type="submit" className="bg-red-600 hover:bg-red-500 text-white font-bold py-2 px-6 rounded shadow-[0_0_15px_rgba(220,38,38,0.4)] transition-all">
                DESTROY PII
              </button>
            </form>
          </div>
        </div>

        {/* STUDENT ACTIVITY TIMELINE */}
        <div className="xl:col-span-2 bg-gray-900 border border-gray-800 rounded-xl shadow-lg p-6 mt-8">
          <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
            <span>⏱️</span> Student Activity Timeline
          </h2>
          <form onSubmit={fetchTimeline} className="flex flex-col sm:flex-row gap-2 mb-6 max-w-md">
            <input 
              type="email" 
              required 
              value={timelineEmail}
              onChange={(e) => setTimelineEmail(e.target.value)}
              placeholder="Search by student email..." 
              aria-label="Student Email for Timeline Search"
              className="flex-1 bg-gray-950 border border-gray-800 text-white rounded p-2 outline-none focus:border-blue-500"
            />
            <button type="submit" className="bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 px-6 rounded transition-all">
              Search
            </button>
          </form>

          <div className="space-y-4 relative border-l-2 border-gray-800 ml-4 pl-6">
            {timelineEvents.length === 0 ? (
              <p className="text-gray-500 text-sm italic">Enter an email to load their timeline.</p>
            ) : (
              timelineEvents.slice(0, 100).map((ev, idx) => (
                <div key={idx} className="relative">
                  {/* Timeline Dot */}
                  <div className={`absolute -left-[33px] top-1 h-4 w-4 rounded-full border-4 border-gray-900 ${ev.type === 'Registration' ? 'bg-green-500' : 'bg-blue-500'}`}></div>
                  <div className="bg-gray-950 p-4 rounded border border-gray-800">
                    <div className="flex justify-between">
                      <span className="font-bold text-white text-sm">{ev.type}</span>
                      <span className="text-gray-500 text-xs">{new Date(ev.created_at).toLocaleString()}</span>
                    </div>
                    <p className="text-gray-400 text-sm mt-1">{ev.details}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default AdminCRM;
